import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import {Provider} from "react-redux";
import {store} from "./_helpers";
import App from "./App";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import createMuiTheme from "@material-ui/core/styles/createMuiTheme";
import blue from '@material-ui/core/colors/blue';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n'; // initialized i18next instance using reactI18nextModule
import registerServiceWorker from "./registerServiceWorker";


const theme = createMuiTheme({
    palette: {
        primary: blue,
    },
});

ReactDOM.render(
    <MuiThemeProvider theme={theme}>
        <Provider store={store}>
            <I18nextProvider i18n={ i18n }>
                <App />
            </I18nextProvider>
        </Provider>
    </MuiThemeProvider>,
    document.getElementById("root")
);
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js